import React from 'react';
import GlobalSearchState from 'main/containers/global_search/state/GlobalSearchState';
import globalSearchStore from 'main/stores/global_search/GlobalSearchStore';
import {SearchableDropdown} from 'shared/components';
import {observer} from 'mobx-react';
/*global window*/

const GlobalSearchContainer = observer(class GlobalSearchContainer extends React.Component {
  handleSelect = (viewModel) => {
    if (viewModel && viewModel.data && viewModel.data.link) {
      window.location = viewModel.data.link;
    }
  };

  render() {
    const {uiState} = this.props;

    return (
      <SearchableDropdown
        suggestions={uiState.sections}
        onQueryChange={(query) => uiState.updateQuery(query)}
        onSelect={this.handleSelect}
      />
    );
  }
});

const GlobalSearchContainerWithState = () => {
  const uiState = new GlobalSearchState(globalSearchStore);
  return <GlobalSearchContainer uiState={uiState}/>;
};

export default GlobalSearchContainerWithState;
